import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_2 = ["src", "loading"]

import { onMounted, ref, watch } from 'vue';

const imagePlaceholder =
	'https://www.signfix.com.au/wp-content/uploads/2017/09/placeholder-600x400.png';

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageLoading',
  props: {
    src: {},
    reload: { type: Boolean },
    imgClass: {},
    loadingClass: {},
    previewable: { type: Boolean },
    isForceLoading: { type: Boolean },
    disabledLazyLoad: { type: Boolean }
  },
  emits: ["click", "load"],
  setup(__props: any, { emit }) {

const props = __props;

const id = ('image-' + Math.random()).replace('.', '');

const isImageLoading = ref(true);
const isError = ref(false);


watch(
	() => props.reload,
	() => {
		if (props.isForceLoading && props.previewable && !props.reload) {
			return;
		}
		isImageLoading.value = props.reload;
	}
);
watch(
	() => isImageLoading.value,
	(value) => !value && emit('load')
);
onMounted(() => {
	if (props.previewable) {
		document.querySelector('.' + id)?.addEventListener('load', () => {
			if (!props.isForceLoading || props.src) {
				isImageLoading.value = false;
			}
		});
	}
});

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isImageLoading.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass('bg-gray-700 rounded-md animate-pulse ' + _ctx.loadingClass),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
        }, [
          _createElementVNode("div", _hoisted_1, [
            (isImageLoading.value)
              ? (_openBlock(), _createBlock(_component_a_spin, {
                  key: 0,
                  tip: "Loading...",
                  size: "large",
                  class: "animate-pulse"
                }))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.previewable)
      ? (_openBlock(), _createBlock(_component_a_image, {
          key: 1,
          src: _ctx.src,
          onError: _cache[1] || (_cache[1] = 
			() => {
				if (!_ctx.isForceLoading || _ctx.src) {
					isImageLoading.value = false;
				}
			}
		),
          class: _normalizeClass(
			(isImageLoading.value ? 'absolute w-0 h-0 opacity-0' : _ctx.imgClass) +
			(' object-cover rounded-md ' + _unref(id))
		),
          fallback: imagePlaceholder
        }, null, 8, ["src", "class"]))
      : (isError.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: imagePlaceholder,
            class: _normalizeClass(_ctx.imgClass + ' object-cover rounded-md')
          }, null, 2))
        : (_openBlock(), _createElementBlock("img", {
            key: 3,
            src: _ctx.src,
            onLoad: _cache[2] || (_cache[2] = 
			() => {
				isImageLoading.value = false;
				isError.value = false;
			}
		),
            onError: _cache[3] || (_cache[3] = 
			() => {
				isImageLoading.value = false;
				isError.value = true;
			}
		),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click'))),
            class: _normalizeClass(
			(isImageLoading.value ? 'absolute w-0 h-0 opacity-0' : _ctx.imgClass) +
			(' object-cover rounded-md ' + _unref(id))
		),
            loading: _ctx.disabledLazyLoad ? undefined : 'lazy'
          }, null, 42, _hoisted_2)),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})